import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./Header.module.css";

import { auth } from "../../firebase";

import ButtonSignOut from "../Buttons/ButtonSignOut";
import ButtonToggleTheme from "../Buttons/ButtonToggleTheme";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import IconCreate from "../Icons/IconCreate";
import IconView from "../Icons/IconView";
import IconReview from "../Icons/IconReview";
import IconSignIn from "../Icons/IconSignIn";
import ButtonOptions from "../Buttons/ButtonOptions";
import NavLinkWithIcon from "../Links/NavLinkWithIcon";

const Header = function (props) {
  const elementHiddenControlsContainer = useRef();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);
  const navigate = useNavigate();

  // HANDLE WINDOW RESIZE
  useEffect(() => {
    const handleWindowResize = function (e) {
      setWindowWidth(e.target.innerWidth);
      if (e.target.innerWidth > 1200) {
        setIsHamburgerOpen(false);
      }
    };
    window.addEventListener("resize", handleWindowResize);
  }, []);

  // HANDLE OPTIONS MENU CLOSING
  const hideHiddenControls = useCallback(function (e) {
    if (!e.target.closest("#hidden-controls")) {
      setIsHamburgerOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isHamburgerOpen) {
      window.addEventListener("click", hideHiddenControls);
    } else {
      window.removeEventListener("click", hideHiddenControls);
    }
  }, [isHamburgerOpen, hideHiddenControls]);

  // HANDLE NAVIGATIONS
  const signOutHandler = function (e) {
    signOut(auth).catch((error) => console.log(error));
    navigate("/");
  };

  const logoOnClickHandler = function () {
    navigate("/");
  };

  // HEADER ELEMENTS
  const headerControls = (
    <Fragment>
      <nav className={styles.nav}>
        <NavLinkWithIcon to="/create-kcard" icon={<IconCreate />}>
          Create Kcard
        </NavLinkWithIcon>
        <NavLinkWithIcon to="/my-kcards" icon={<IconView />}>
          My Kcards
        </NavLinkWithIcon>
        <NavLinkWithIcon to="/review" icon={<IconReview />}>
          Review
        </NavLinkWithIcon>
        <ButtonSignOut />
      </nav>
    </Fragment>
  );

  const headerControlsTablet = (
    <nav className={styles.nav}>
      <NavLink
        to="/create-kcard"
        className={({ isActive }) =>
          isActive
            ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
            : styles["nav-link"]
        }
      >
        <IconCreate strokeWidth={0.5} />
      </NavLink>
      <NavLink
        to="/my-kcards"
        className={({ isActive }) =>
          isActive
            ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
            : styles["nav-link"]
        }
      >
        <IconView strokeWidth={0.5} />
      </NavLink>
      <NavLink
        to="/review"
        className={({ isActive }) =>
          isActive
            ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
            : styles["nav-link"]
        }
      >
        <IconReview strokeWidth={0.5} />
      </NavLink>
      <ButtonOptions
        className={
          isHamburgerOpen
            ? `${styles.options} ${styles["options-open"]}`
            : styles.options
        }
        setIsHamburgerOpen={setIsHamburgerOpen}
        isOpen={isHamburgerOpen}
      />
    </nav>
  );

  const headerControlsMobile = (
    <Fragment>
      <div className={styles["logo-container"]}>
        <img
          className={styles.img}
          src={require("../../assets/logo-180.png")}
          alt="KCards app logo"
          onClick={logoOnClickHandler}
        />
      </div>
      <nav className={styles.nav}>
        <NavLink
          to="/create-kcard"
          className={({ isActive }) =>
            isActive
              ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
              : styles["nav-link"]
          }
        >
          <IconCreate strokeWidth={0.5} />
        </NavLink>
        <NavLink
          to="/my-kcards"
          className={({ isActive }) =>
            isActive
              ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
              : styles["nav-link"]
          }
        >
          <IconView strokeWidth={0.5} />
        </NavLink>
        <NavLink
          to="/review"
          className={({ isActive }) =>
            isActive
              ? `${styles["nav-link-active"]} ${styles["nav-link"]}`
              : styles["nav-link"]
          }
        >
          <IconReview strokeWidth={0.5} />
        </NavLink>
        <ButtonOptions
          className={
            isHamburgerOpen
              ? `${styles.options} ${styles["options-open"]}`
              : styles.options
          }
          setIsHamburgerOpen={setIsHamburgerOpen}
          isOpen={isHamburgerOpen}
        />
      </nav>
    </Fragment>
  );

  const headerHiddenControlsTablet = (
    <div
      id="hidden-controls"
      className={`${styles["hidden-header-controls"]}`}
      ref={elementHiddenControlsContainer}
    >
      <ButtonSignOut className={styles["menu-btn"]} onClick={signOutHandler} />
    </div>
  );

  const headerHiddenControlsMobile = (
    <div
      id="hidden-controls"
      className={`${styles["hidden-header-controls"]}`}
      ref={elementHiddenControlsContainer}
    >
      <div className={styles["theme-container"]}>
        <span className={styles["theme-text"]}>Theme</span>
        <ButtonToggleTheme />
      </div>
      <ButtonSignOut className={styles["menu-btn"]} onClick={signOutHandler} />
    </div>
  );

  const logoContent = (
    <div className={styles["logo-container"]}>
      <img
        className={styles.img}
        src={require("../../assets/logo-180.png")}
        alt="KCards app logo"
        onClick={logoOnClickHandler}
      />
      <div>
        <h1 className={styles["logo__text"]}>
          Flash cards <br /> made easy.
        </h1>
        <ButtonToggleTheme />
      </div>
    </div>
  );

  return (
    <header className={styles.header}>
      <div className={styles["header-container"]}>
        {!props.isSignedIn && logoContent}
        {!props.isSignedIn && (
          <NavLinkWithIcon to="/login" icon={<IconSignIn />}>
            Sign in
          </NavLinkWithIcon>
        )}
        {props.isSignedIn && windowWidth > 1200 && logoContent}
        {props.isSignedIn && windowWidth > 1200 && headerControls}
        {props.isSignedIn &&
          windowWidth <= 1200 &&
          windowWidth > 600 &&
          logoContent}
        {props.isSignedIn &&
          windowWidth <= 1200 &&
          windowWidth > 600 &&
          headerControlsTablet}
        {props.isSignedIn && windowWidth <= 600 && headerControlsMobile}
        {props.isSignedIn &&
          isHamburgerOpen &&
          windowWidth <= 1200 &&
          windowWidth > 600 &&
          headerHiddenControlsTablet}
        {props.isSignedIn &&
          isHamburgerOpen &&
          windowWidth <= 600 &&
          headerHiddenControlsMobile}
      </div>
    </header>
  );
};

export default Header;
